import { LabelLayer } from "../layers/server/LabelLayer";
import { ThematicLayer } from "../layers/server/ThematicLayer";
import { TileLayer } from "../layers/server/TileLayer";
import { ImageLayer } from "../layers/server/ImageLayer";
import { WMTSLayer } from "../layers/server/WMTSLayer";
import { VectorLayer } from "../layers/server/VectorLayer";
import { register } from "ol/proj/proj4";
import proj4 from 'proj4';
import { is_grouped } from "../gsa/Config";
import { WMTSPictometryLayer } from "../layers/server/WMTSPictometryLayer";
export class Loader {
    constructor(config) {
        var _a, _b;
        this.config = config;
        this.min_resolution = (_a = config.MinResolution) !== null && _a !== void 0 ? _a : 0.43402777777777773;
        this.max_resolution = (_b = config.MaxResolution) !== null && _b !== void 0 ? _b : 434.02777777777777;
    }
    register_projections() {
        if (this.config.Projections) {
            try {
                Object.getOwnPropertyNames(this.config.Projections).forEach(name => {
                    proj4.defs("EPSG:" + name, this.config.Projections[name]);
                });
                register(proj4);
            }
            catch (err) {
                console.warn(`${err} \n The GIS Config file has missing/malformed projection definition(s). Please add/modify relevant projection definition(s) in Projections section.`);
            }
        }
    }
    async create_layers() {
        this.register_projections();
        let finals = [];
        let layers = [...this.config.Layers];
        if (!this.config.MultipleBaseLayersEnabled && layers.filter(x => x.isBaseLayer && x.visible).length > 1) {
            var first_visible_baselayer_from_config = layers.find(x => x.isBaseLayer && x.visible);
            layers = layers.map(x => {
                if (x.isBaseLayer && x !== first_visible_baselayer_from_config)
                    x.visible = false;
                return x;
            });
        }
        for (let layer_def of layers) {
            switch (layer_def.type.toLowerCase()) {
                case 'image':
                    finals.push(new ImageLayer(layer_def));
                    break;
                case 'tile':
                    finals.push(new TileLayer(layer_def));
                    break;
                case 'wmts':
                    finals.push(new WMTSLayer(layer_def));
                    break;
                case 'wmtspictometry':
                    finals.push(new WMTSPictometryLayer(layer_def));
                    break;
                case 'vector':
                    finals.push(new VectorLayer(layer_def));
                    break;
                case 'label':
                    finals.push(new LabelLayer(layer_def));
                    break;
                case 'dynamic':
                    layer_def = layer_def;
                    if (is_grouped(layer_def)) {
                        for (let subdef of layer_def.layerGroups) {
                            let modified = {
                                name: subdef.name,
                                infoUrl: layer_def.infoUrl,
                                exportUrl: layer_def.exportUrl,
                                isBaseLayer: layer_def.isBaseLayer,
                                visible: layer_def.visible,
                                opacity: subdef.opacity,
                                details: layer_def.details,
                                group_visible: subdef.visible,
                                group_field: subdef.field,
                                group_as_label: subdef.as_label,
                                group_layers: subdef.layers,
                                authRequired: layer_def.authRequired,
                                authUser: layer_def.authUser,
                                authPassword: layer_def.authPassword,
                            };
                            finals.push(new ThematicLayer(modified));
                        }
                    }
                    else {
                        finals.push(new ThematicLayer(layer_def));
                    }
                    break;
                default: break;
            }
        }
        while (finals.some(l => !l.loaded)) {
            await new Promise(res => setTimeout(res, 20));
        }
        let count = 0;
        finals.filter(l => l.is_base).forEach(l => {
            l.raw.map(r => r.setZIndex(count++));
        });
        finals.filter(l => l instanceof ThematicLayer).forEach(l => l.raw.map(r => r.setZIndex(count++)));
        finals.filter(l => !l.is_base && !(l instanceof ThematicLayer)).forEach(l => {
            l.raw.map(r => r.setZIndex(count++));
        });
        let baselayer = finals.find(l => l.is_base && l.visible && !l.parsing_failed);
        if (!baselayer)
            baselayer = finals.find(l => l.is_base && !l.parsing_failed);
        if (!baselayer) {
            throw Error("No base layer defined in config. Cannot continue.");
        }
        if (baselayer instanceof WMTSPictometryLayer) {
            return finals;
        }
        let base_api = await baselayer.get_service_api();
        if (base_api) {
            this.min_resolution = Math.min(...base_api.cached_resolutions, this.min_resolution);
            this.max_resolution = Math.max(...base_api.cached_resolutions, this.max_resolution);
        }
        return finals;
    }
}
